import { siteConfig } from "../data/siteConfig";

export function buildWhatsAppUrl(message: string = siteConfig.whatsappMessage) {
  return `https://wa.me/${siteConfig.phoneRaw}?text=${encodeURIComponent(message.trim())}`;
}

export function openWhatsApp(message: string) {
  const opened = window.open(buildWhatsAppUrl(message), "_blank", "noopener,noreferrer");
  if (opened) opened.opener = null;
  return Boolean(opened);
}

export function safeExternalUrl(url: string) {
  if (!url) return null;

  try {
    const parsed = new URL(url);
    return parsed.protocol === "https:" ? parsed.toString() : null;
  } catch {
    return null;
  }
}
